import * as BuilderUI from '../../../../components/Builder/BuilderUI';
import ReportFilter from '../../../../components/Builder/ReportFilter';
import {
  significanceBuilderCriteriaInfo,
  significanceBuilderMetricInfo,
} from './utils/tooltips';
import SectionHeading from '../../../../components/SectionHeading';
import SignificanceBuilderHeader from './SignificanceBuilderHeader';
import SignificanceTestSettings from './SignificanceTestSettings';
import SignificanceMetric from './SignificanceMetric';
import SignificanceCriteria from './SignificanceCriteria';
import BuilderExecutionDateRange from '../../../../components/Builder/BuilderExecutionDateRange';
import SignificanceExecute from './SignificanceExecute';
import useShowCloseLlmPrompt from '../../../../components/Builder/LlmPrompt/useShowCloseLlmPrompt';
import LlmPrompt from '../../../../components/Builder/LlmPrompt';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import React from 'react';

const SignificanceBuilder = () => {
  const { showLlmPrompt, handleCloseLlmPrompt } = useShowCloseLlmPrompt();

  return (
    <>
      <SignificanceBuilderHeader />
      {showLlmPrompt && (
        <LlmPrompt
          queryType={QueryType.Significance}
          onClose={handleCloseLlmPrompt}
        />
      )}
      <BuilderUI.Part1>
        <SectionHeading
          heading="Significance Criteria"
          tooltipOption={significanceBuilderCriteriaInfo}
        />
        <SignificanceCriteria />
        <SignificanceTestSettings />
        <BuilderUI.HorizontalDivider />
        <SectionHeading
          heading="Metric"
          tooltipOption={significanceBuilderMetricInfo}
        />
        <SignificanceMetric />
      </BuilderUI.Part1>
      <BuilderUI.Part2>
        <ReportFilter />
        <BuilderUI.HorizontalDivider />
        <BuilderExecutionDateRange />
      </BuilderUI.Part2>
      <SignificanceExecute />
    </>
  );
};

export default SignificanceBuilder;
